module.exports = __webpack_public_path__ + "static/media/edit.d116e58e.svg";